import React from 'react';

const XIcon = () => {
    return (
        <svg>
            <path d='M8 8 L24 24 M8 24 L24 8' />
        </svg>
    );
};

export default XIcon;
